import React, {useState, useEffect} from 'react';
import { Link } from 'react-router-dom';
import "./style.css";
import { getTokenInfo } from './../../UseToken';
import Hosts from "../../Hosts"
//import { Redirect } from 'react-router-dom';

import {
    reqGET,
    set_language,
	repo_logo_link,
    repo_icons_link,

} from '../../Utils';

import { language } from '../WEBContent/Language';
//import { walk } from 'react-sortable-tree';



function logout() {
    localStorage.clear();

    //console.log('CAHCE LIMPA');
    //< Redirect to='/simconference' replace />
    //window.location.href = '/chucb-conference-gest';
}
//  <img src="./img/logo-icon.png" alt="Fasquia Importante" className="light-logo-mobile" />
//<img  src="./img/logo.png" alt="Fasquia Importante" className="light-logo " />
const Header = (props) => {
    //let id = getTokenInfo().id;
    let username = getTokenInfo().name;
    let profile = getTokenInfo().profile;
    //let office = getTokenInfo().office.name;

    const [lang, set_lang] = useState('pt');

    const [messages_unread, set_messages_unread] = useState([]);
    const [notification_notes, set_notification_notes] = useState([]);

    const change_lang = (l) => {
        set_language(l)
        set_lang(l)
        window.location.reload()

        //console.log('language', localStorage.getItem('lang'))
        //console.log('localstorage', localStorage)
    }

    useEffect(() => {
		
        let today = new Date()
        let d_today = today.getFullYear() + '-' + ((today.getMonth() + 1) + '').padStart(2, '0') + '-' + (today.getDate() + '').padStart(2, '0') 

        if(localStorage.getItem('lang') === undefined  || localStorage.getItem('lang') === null || localStorage.getItem('lang') === '') {
            change_lang('pt')
        }
        else {
            set_lang(localStorage.getItem('lang'))
        }

        reqGET(`${Hosts.SIMCore_API}/app/messages/unread/to/${Hosts.companycode}/${getTokenInfo().id}`)
            .then(res => {

                set_messages_unread(res.data)

            })
            .catch(erro => console.log('Erro Mensagens', erro))

        reqGET(`${Hosts.SIMCore_API}/app/notes/notification/${Hosts.companycode}/${d_today}/${getTokenInfo().id}`)
            .then(res => {

                let aux = []
                res.data.forEach(el => {
                    if(el.info['notified'] !== undefined && el.info['notified'] === false) {
                        aux.push(el)
                    }
                })
                set_notification_notes(aux)

            })
            .catch(erro => console.log('Erro Mensagens', erro))

	}, [])

    return (
        <header>
            <nav className="navbar top-navbar navbar-light">
                <div className="navbar-header">
                    <div className="navbar-brand">
                        <a href={Hosts.WEB_BACKOFFICE_URI}>

                            <img src={repo_logo_link("logo.svg")} alt={Hosts.webSiteTitle} title={Hosts.webSiteTitle} className="light-logo-mobile" />
                            <img src={repo_logo_link("logo.svg")} alt={Hosts.webSiteTitle} title={Hosts.webSiteTitle} className="light-logo " />
                        </a>
                    </div>
                </div>

                <div className="navbar-collapse collapse">
                    <ul className="navbar-nav float-left">
                    </ul>
                    <ul className="navbar-nav float-right" style={{marginRight: '70px'}}>
                        <li className="nav-item d-none">
                            <a href={Hosts.WEB_BACKOFFICE_URI} className="nav-link">
                                <span className="ti-search"></span>
                            </a>
                        </li>  

                        {/*
                        <li className={notification_notes.length > 0 ? 'nav-item' : 'nav-item d-none-'}>
                            <a href={Hosts.WEB_BACKOFFICE_URI + "/app_notes_list"} alt={language[lang].note} title={language[lang].note} className="nav-link">
                                <button type="button" className="btn btn-light position-relative">
                                    <i className="bi bi-bell"></i>
                                    <span className={"position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger" + (notification_notes.length > 0 ? '' : ' d-none')}>
                                        {notification_notes.length}
                                    </span>
                                </button>
                            </a>
                        </li>

                        <li className={messages_unread.length > 0 ? 'nav-item' : 'nav-item d-none-'}>
                            <a href={Hosts.WEB_BACKOFFICE_URI + "/app_messages_list"} alt={language[lang].unread_messages} title={language[lang].unread_messages} className="nav-link">
                                <button type="button" className="btn btn-light position-relative">
                                    <i className="bi bi-envelope"></i>
                                    <span className={"position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger" + (messages_unread.length > 0 ? '' : ' d-none')}>
                                        {messages_unread.length}
                                    </span>
                                </button>
                            </a>
                        </li>
                        */}

                        <li className="nav-item d-none">    
                            <button  className={"nav-link " + (lang === 'pt' ? 'assec-current-lang': '')} onClick={() => change_lang('pt')}>PT</button>
                            <span className='nav-link assec-pr-5 assec-pl-5'>|</span>
                            <button  className={"nav-link " + (lang === 'en' ? 'assec-current-lang': '') } onClick={() => change_lang('en')}>EN</button> 
                        </li>                 
                        
                        <li className="nav-item">
                            <a href={Hosts.WEB_BACKOFFICE_URI} className="nav-link">
                                <img alt='' src={repo_icons_link("user.svg")} />
                                <span>{`${username}`}</span>
                            </a>
                        </li>
                        <li className="nav-item">
                            <a href={Hosts.WEB_BACKOFFICE_URI} onClick={logout} className="nav-link">
                                <img alt='' src={repo_icons_link("sair.svg")} />
                                <span>{language[lang].logout}</span>
                            </a>
                        </li>
                        <li className="nav-item">
                            <a href={Hosts.WEB_SITE_URI} target="_blank" rel="noreferrer" className="nav-link">
                                <img alt='' src={repo_icons_link("website.svg")} />
                                <span>{language[lang].web_page}</span>
                            </a>
                        </li>
                    </ul>
                </div>
            </nav>
        </header>
    );
}

export default Header;